<template>
  <div class="default-layout">
    <app-spinner v-if="!is_loaded" />
    <div v-else-if="!user" class="profile-error"><p>Unable to load your profile.</p><app-button @click.native="refreshPermissions">Retry</app-button></div>
    <template v-else>
      <app-sidebar :user="user" />
      <main class="main" :class="{ 'main--full': !isPinActive }" :style="mainStyle">
        <div v-if="isUserView" class="back-to-admin">
          <app-button @click.native="onBackToAdmin" size="small" theme="warn">Back to admin</app-button>
        </div>
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </main>
      <support-ticket-launcher />
    </template>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar'
import { allowsAccess } from '@/utils/permissionAccess'
import SupportTicketLauncher from '@/views/tech-support/tickets/components/SupportTicketLauncher'
import { isLoggedIn, setAuthTokens } from 'axios-jwt'

export default {
  components: { AppSidebar, SupportTicketLauncher },
  data() {
    return {
      is_loaded: false,
      user: null,
    }
  },
  created() {
    if (isLoggedIn()) {
      this.$store.dispatch('permissions/refreshProfile')
        .then(profile => {
          if (!profile) return
          this.user = profile
          this.is_loaded = true
          if (this.$route.name === 'base') {
            if (this.user.groups.length && this.user.groups[0].index_page) {
              this.$router.push({ name: this.user.groups[0].index_page }).catch(() => {})
            } else {
              this.$router.push({ name: 'users' }).catch(() => {})
            }
          }
        }).catch(() => { this.is_loaded = true })
    }
  },
  computed: {
    mainStyle() {
      const style = this.$route.meta.compactMain ? { padding: 0 } : {}
      if (this.$route.meta.mainBackground) style.backgroundColor = this.$route.meta.mainBackground
      if (this.$route.meta.fullHeightMain) style.minHeight = '100vh'
      return style
    },
    isPinActive() {
      return this.$store.state.isBigSidebar
    },
    isUserView() {
      return localStorage.getItem('access_admin')
    },
    getAccessAdmin() {
      return localStorage.getItem('access_admin')
    },
    getRefreshAdmin() {
      return localStorage.getItem('refresh_admin')
    },
  },
  methods: {
    async refreshPermissions() {
      try {
        const profile = await this.$store.dispatch('permissions/refreshProfile')
        if (profile) {
          this.user = profile
          this.is_loaded = true
        }
        const access = this.$route.meta.access
        const allowed = allowsAccess(access, profile, this.$store.getters['permissions/can'])
        if (access && !allowed) this.$router.replace({ name: 'access-denied' }).catch(() => {})
      } catch (_) {
        if (this.$route.meta.access) this.$router.replace({ name: 'access-denied' }).catch(() => {})
      }
    },
    onBackToAdmin() {
      this.$store.commit('permissions/reset')
      const user_groups_admin = JSON.parse(localStorage.getItem('user_groups_admin'))
      this.$store.commit('setUserGroups', user_groups_admin)
      setAuthTokens({
        accessToken: this.getAccessAdmin,
        refreshToken: this.getRefreshAdmin
      })
      localStorage.removeItem('access_admin')
      localStorage.removeItem('refresh_admin')
      localStorage.removeItem('user_groups_admin')
      location.assign('/common/users')
    }
  }
}
</script>

<style lang="sass" scoped>
.back-to-admin
  position: fixed
  bottom: 10px
  right: 40px
  z-index: 999

.default-layout
  flex-grow: 1
  display: flex

.main
  flex-grow: 1
  min-width: 0
  margin-left: 220px
  padding: 35px 40px
  transition: margin-left 0.3s, padding 0.3s

  +max-w($desktop_sm)
    margin-left: 200px
    padding: 25px 15px

.main--full
  margin-left: 60px
  transition: margin-left 0.3s

.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
